import React, { useState, useCallback, useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { showSuccessSnackbar } from 'modules/snackbar';

import MbTabs from 'components/organisms/MbTabs';
import MainTemplate from 'pages/templates/MainTemplate';

import Dashboard from './Dashboard';
import Statistics from './Statistics';
import RequestList from './RequestList';
import MonthCnt from './MonthCnt';
import User from './User';

const Script = ({ location }) => {
  let { path } = useRouteMatch();
  const dispatch = useDispatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));
  const [loading, setLoading] = useState(true);
  const [pathName, setPathName] = useState(window.location.pathname);

  useEffect(() => {
    if (window.location.pathname !== pathName) {
      setPathName(window.location.pathname);
      setLoading(true);
    } // eslint-disable-next-line
  }, [window.location.pathname]);

  const handleLoading = (value) => {
    setLoading(value);
  };

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  const solution = [
    { 'CODE_ID': '01', 'CODE_VAL': 'cafe24', 'CODE_DESC': '카페24' },
    { 'CODE_ID': '03', 'CODE_VAL': 'godo', 'CODE_DESC': '고도몰' },
    { 'CODE_ID': '02', 'CODE_VAL': 'makeshop', 'CODE_DESC': '메이크샵' },
    { 'CODE_ID': '07', 'CODE_VAL': 'imweb', 'CODE_DESC': '아임웹' },
    { 'CODE_ID': '98', 'CODE_VAL': 'self', 'CODE_DESC': '독립몰' },
    { 'CODE_ID': '99', 'CODE_VAL': 'contact', 'CODE_DESC': '문의' },
    { 'CODE_ID': '08', 'CODE_VAL': 'sixshop', 'CODE_DESC': '식스샵' },
    { 'CODE_ID': '06', 'CODE_VAL': 'wisa', 'CODE_DESC': '위사몰' },
    { 'CODE_ID': '04', 'CODE_VAL': 'first', 'CODE_DESC': '퍼스트몰' },
    { 'CODE_ID': '05', 'CODE_VAL': 'whoismall', 'CODE_DESC': '후이즈몰' },
    { 'CODE_ID': '09', 'CODE_VAL': 'wordPrass', 'CODE_DESC': '워드프레스' },
    { 'CODE_ID': '12', 'CODE_VAL': 'blogPay', 'CODE_DESC': '가비아' },
    { 'CODE_ID': '11', 'CODE_VAL': 'wix', 'CODE_DESC': '윅스' },
    { 'CODE_ID': '10', 'CODE_VAL': 'blogPay', 'CODE_DESC': '블로그페이' },
    { 'CODE_ID': '97', 'CODE_VAL': 'self', 'CODE_DESC': '메타태그' },
    { 'CODE_ID': '96', 'CODE_VAL': 'self', 'CODE_DESC': '추가점수' },
  ];

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <MainTemplate loading={loading}>
      <MbTabs
        name="Script"
        tabMenuList={tabList()}
        tabs={{
          '/script/dashboard': {
            tabComponent: (
              <Dashboard
                solution={solution}
                handleClickSnackbar={handleClickSnackbar}
                handleLoading={handleLoading}
              />
            ),
          },
          '/script/requestList': {
            tabComponent: (
              <RequestList
                solution={solution}
                handleClickSnackbar={handleClickSnackbar}
                handleLoading={handleLoading}
              />
            ),
          },
          '/script/statistics': {
            tabComponent: (
              <Statistics
                handleClickSnackbar={handleClickSnackbar}
                handleLoading={handleLoading}
              />
            ),
          },
          '/script/monthCnt': {
            tabComponent: <MonthCnt handleLoading={handleLoading} />,
          },
          '/script/user': {
            tabComponent: (
              <User
                handleLoading={handleLoading}
                handleClickSnackbar={handleClickSnackbar}
              />
            ),
          },
        }}
      />
    </MainTemplate>
  );
};

export default Script;
